import { FC, useContext, useMemo } from 'react';
import { isMobile } from 'react-device-detect';
import { CategoryPageContext } from 'src/constructors/pageConstructors/CategoryPageConstructor';
import { HomePageContext } from 'src/constructors/pageConstructors/HomePageConstructor';
import BannerSlider from './BannerSlider';

type Props = {
  settings: any;
  type: string;
};

const Slider: FC<Props> = ({ settings, type }) => {
  const homePageContext = useContext(HomePageContext);
  const categoryPageContext = useContext(CategoryPageContext);

  const sliderData = useMemo(() => {
    switch (type) {
      case 'home':
        return isMobile
          ? homePageContext?.pageFields?.sliderMobile?.[0]
          : homePageContext?.pageFields?.sliderDesktop?.[0];
      case 'category':
        return isMobile
          ? categoryPageContext?.pageFields?.sliderMobile?.[0]
          : categoryPageContext?.pageFields?.sliderDesktop?.[0];
      default:
        return null;
    }
  }, [homePageContext, categoryPageContext, settings?.data?.pageContext]);

  return <BannerSlider settings={settings.data.settings} sliderData={sliderData} />;
};
export default Slider;
